import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NbWindowService, NbWindowState, NbDialogService } from '@nebular/theme';
import { UserEditComponent } from '../../user-edit/user-edit.component'
import { ConfirmDialogComponent } from '../../utils/confirm-dialog/confirm-dialog.component'
import { User } from '../../../@core/data/users';
import { UserService } from '../../../@core/api/users.service';
import { LenguageService } from '../../../@core/utils/lenguage.service'


@Component({
  selector: 'ngx-user-row',
  templateUrl: './user-row.component.html',
  styleUrls: ['./user-row.component.scss']
})
export class UserRowComponent implements OnInit {
  loading: boolean = false;
  @Input() user: User;
  @Input() embed: boolean = false;
  @Input() selected: boolean = false;
  @Output() selectRow = new EventEmitter<Object>();
  service: any;
  admin: boolean;

  constructor(
    public language: LenguageService,
    private windowService: NbWindowService, 
    private dialogService: NbDialogService,
    private userService: UserService) {

  }

  async ngOnInit() {
    let logged = await this.userService.getLoggedUser()
    this.admin = (logged.userType === "admin") ? true : false;

  }


  action(type) {
    switch (type) {
      case 'select':
        this.selected = true;
        this.selectRow.emit({
          select: true,
          id: this.user.uid
        })
        break;

      case 'deselect':
        this.selected = false;
        this.selectRow.emit({
          select: false,
          id: this.user.uid
        })

        break;
    }
  }

  show(type) {

    switch (type) {
      case "edit":
        this.windowService.open(UserEditComponent, { context: { user: this.user, embed: true, id: this.user.uid }, title: "Modifica - " + this.user.name })
          .onClose.subscribe(() => this.UpdateUser())
        break;

      case "delete":
        this.dialogService.open(ConfirmDialogComponent, { context: { operation: "eliminare l'account di " + this.user.name } })
          .onClose.subscribe((res) => {
            if (res) {
              this.DeleteUser()
            }
          })
        break;
    }

  }

  async UpdateUser() {
    this.loading = true;
    this.user = await this.userService.getUser(this.user.uid);
    this.loading = false;

  }


  async DeleteUser() {
    this.loading = true;
    await this.userService.deleteUser(this.user.uid);
    this.loading = false;

  }

  userTypes = {
    "user": "User",
    "admin": "Amministratore"
  }

  plans = {
    "free": "Free",
    "professional": "Professional"
  }


}
